import tagsTypes, { customTagsTypes, getOriginalByCustomCategory } from "constants/tagsTypes";
import isRTX from "./isRTX";

const sanitizeCategory = (option: any, orgName?: string) => {
  const replaceableTypes = {
    [tagsTypes.YEARS_IN_PROGRAM]: tagsTypes.CLASS_YEARS,
    [customTagsTypes.BUSINESSES]: isRTX(orgName) ? tagsTypes.COMPANIES : tagsTypes.DEPARTMENTS
  };

  return replaceableTypes[option.category] || getOriginalByCustomCategory(option.category);
};

export default sanitizeCategory;
